import { UserLocationSave } from "../user-location-save";

export class SupportRequest{
    public AuditDetails:string = "";
    public RequestDetails:string = "";
    public UserID:number = -1;
     constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}